<!-- /SixthSection/ -->
<template>
    <div class="backgroundColor">
        <div class="sixthSectionContainer">
            <div class="leftBox">
                <div class="titleContainer">
                    <span class="title">
                        Une marketplace ouverte vers le monde bancaire
                    </span>
                </div>
                <p>
                    Prexange est une marketplace de dossiers de financement publiés par des sociétés de courtage, certifiés par nos analystes avant publication ; elle représente un flux constant de dossiers à portée de main des organismes de financement
                </p>
                <p>
                    <span class="bold">En amont, côté Prexange :</span><br>
                    Un analyste Prexange certifie la cohérence et la complétude des informations transmises par le
                    courtier
                    ainsi que la demande de prêt. <br><br>
                    <span class="bold">Puis, Coté Banques:</span>
                </p>
                <div class="first">
                    <div class="left">
                        <img :src="icon1" alt="icon1">
                        <div>
                            <span class="bold">01 - CONNEXION</span>
                            <p>
                                Connexion à la plateforme et recherche des dossiers disponibles via un moteur de
                                recherche
                                avancé.
                            </p>
                        </div>
                    </div>
                    <div class="left">
                        <img :src="icon2" alt="icon2">
                        <div>
                            <span class="bold">03 - POSITIONNEMENT</span>
                            <p>
                                Positionnement sur le dossier à partir des éléments anonymisés et de la demande de prêt.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="first">
                    <div class="left">
                        <img :src="icon3" alt="icon3">
                        <div>
                            <span class="bold">02 - ENRICHISSEMENT</span>
                            <p>
                                Enrichissement de la base de dossiers en les ajoutant aux favoris, les dossiers sont
                                rapidement accessibles.
                            </p>
                        </div>
                    </div>
                    <div class="left">
                        <img :src="icon4" alt="icon4">
                        <div>
                            <span class="bold">04 - TELETRANSMISSION</span>
                            <p>
                                Télétransmission du dossier complet si la réponse du client via le courtier est positive
                                assurance d'un taux de conquête élevé.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <img class="Image" :src="image" alt="image">
            </div>
        </div>
    </div>
</template>

<script>

import icon1 from '@/assets/images/icon1.png';
import icon2 from '@/assets/images/icon2.png';
import icon3 from '@/assets/images/icon3.png';
import icon4 from '@/assets/images/icon4.png';
import image from '@/assets/images/Samsung.png';


export default {
    name: 'SixthSection',
    data() {
        return {
            image: image,
            icon1: icon1,
            icon2: icon2,
            icon3: icon3,
            icon4: icon4,
            isSidebarOpen: false,
        };
    },
};
</script>


<style lang="scss">
@import './SixthSection.scss'
</style>